import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import ToastAx      from 'app/actions/toast';
import BackstageApi from 'app/apis/backstage';
import Modal        from 'app/components/common/modal';
import RadioButton  from 'app/components/common/radio-button';

class ModalNonprofitPercentOrg extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      orgObjs: null,
      selectedId: null,
      isSaving: false,
    };

    this.onClose = this.onClose.bind(this);
    this.onChangeSelected = this.onChangeSelected.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentDidMount() {
    this.fetchOrgObjs();
  }

  get selectedId() {
    return this.state.selectedId || this.props.currentPercentId;
  }

  fetchOrgObjs() {
    if (this.state.isLoading || this.state.isSaving) return;
    this.setState({isLoading: true});
    BackstageApi.nonprofitsFetchPercentOrgs(this.props.nonprofitId).then(({percentObjs}) => {
      this.setState({orgObjs: percentObjs, isLoading: false});
    });
  }

  onChangeSelected(event) {
    const selectedId = event.target.value;
    this.setState({selectedId});
  }

  onClose(shouldRefresh=false) {
    this.props.onClose(shouldRefresh);
  }

  onClickSave() {
    if (this.state.isLoading || this.state.isSaving) return;
    this.setState({isSaving: true});
    BackstageApi.nonprofitsUpdatePercentOrg(this.props.nonprofitId, this.selectedId).then(() => {
      this.setState({isSaving: false, selectedId: null});
      this.props.toastSuccess('Percent org assigned.');
      this.onClose(true);
    }).catch((error) => {
      console.error(error);
      this.setState({isSaving: false});
      this.props.toastError('Oops! Something went wrong. Error logged to console.');
    });
  }

  renderOrgs() {
    const {isLoading, orgObjs} = this.state;
    if (isLoading) {
      return <p>loading...</p>;
    }

    return (
      <div className="bs-porgs-list">
        {(orgObjs || []).map((org) => {
          const isSelected = this.selectedId === org.id;
          return (
            <label id={org.id} key={org.id} className={`bs-porgs-org-item ${isSelected ? 'selected' : ''}`}>
              <RadioButton value={org.id} checked={isSelected} onChange={this.onChangeSelected} />
              <div className="bs-porgs-org-item-name">{org.name}</div>
              <div className="bs-porgs-org-item-line">{org.address}</div>
              <div className="bs-porgs-org-item-line">{org.website}</div>
              <div className="bs-porgs-org-item-line">{org.id}</div>
              <div className="bs-porgs-org-item-line">Claimed: {!!org.claimedAt ? 'yes' : 'no'}</div>
              <div className="bs-porgs-org-item-desc">{org.description}</div>
            </label>
          );
        })}
      </div>
    );
  }

  render() {
    const btnDisabled = (() => {
      if (this.state.isLoading) return true;
      if (this.state.isSaving) return true;
      if (!this.selectedId) return true;
      if (this.selectedId === this.props.currentPercentId) return true;
      return false;
    })();
    const btnText = this.state.isSaving ? 'Assigning...' : 'Assign Selected Org to Nonprofit';
    return (
      <Modal onClose={this.onClose} className="bform bs-porgs">
        <h1 className="bform-h1">Percent Orgs</h1>
        <p>These are the orgs Percent has listed for this nonprofit's EIN/Registered Number. Choose the one that donations should be disbursed to.</p>
        {this.renderOrgs()}
        <div className="bform-actions">
          <div className="bform-actions-left" />
          <button className="btn blue" onClick={this.onClickSave} disabled={btnDisabled}>{btnText}</button>
        </div>
      </Modal>
    );
  }

}

ModalNonprofitPercentOrg.propTypes = {
  nonprofitId: PropTypes.string.isRequired,
  currentPercentId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({});
const dispatchToProps = (dispatch) => ({
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
  toastError: (msg) => dispatch(ToastAx.error(msg)),
});

export default connect(stateToProps, dispatchToProps)(ModalNonprofitPercentOrg);
